import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private isCollapsedSubject = new BehaviorSubject<boolean>(false);
  public isCollapsed$: Observable<boolean> = this.isCollapsedSubject.asObservable();

  private navigateToSubject = new Subject<string>();
  public navigateTo$ = this.navigateToSubject.asObservable();

  setCollapsed(value: boolean): void {
    this.isCollapsedSubject.next(value);
  }

  getCollapsed(): boolean {
    return this.isCollapsedSubject.value;
  }

  navigateTo(url: string): void {
    this.navigateToSubject.next(url);
  }
}
